<template>
    <div>
        <tab name="4">{{id}} {{data && data.activityName}} <b v-if="data && data.haveEditAudit" class="color-danger">存在还未处理的演出修改审核，请处理后再编辑演出信息</b></tab>
        <div v-if="$utils.have('/activity/saveTPs') && data && !data.channelName" class="page-btns-box">
           <!-- <el-button  type="primary" icon="el-icon-plus" @click="add" size="small" :disabled="data && data.haveEditAudit" v-if="data && !data.activityChannel ">添加票品</el-button> -->
			<el-button
				v-if="data && !data.channelName  "
				type="primary"
				size="small"
				icon="el-icon-plus"
				@click="addShowstart()"
				:disabled="data && data.haveEditAudit"
				>添加票品</el-button
			><!-- 秀动 -->
			<el-button
				v-else
				type="primary"
				size="small"
				 icon="el-icon-plus"
				@click="add()"
				 :disabled="data && data.haveEditAudit"
				>添加票品</el-button
			><!-- 非秀动 -->
			
			
            <!-- <el-button  type="primary" icon="el-icon-upload2" @click="add" size="small">快速添加票品</el-button> -->
        </div>
        <div class="page-list-box" v-loading="dataLoading">
            <div v-for="(item,index) in dataList" :key="index">
                <div class="page-group-title">
                    <span>{{item.sessionName}}</span>
                    <small class="MR20">({{item.time}})</small>
					<el-button type="primary" size="mini"  v-if="item.supportSeatSetting"   icon="el-icon-upload"  @click="setSeat(item)">
						<span v-if="item.siteFileUrl">管理座位号</span>
						<span v-else>导入座位号 </span>
					</el-button>
                </div>
                <el-table
                    :data="item.ticketPrices"
                    border
                    style="width: 100%"
                    size="small"
                    stripe
                    row-key="id"
                    :class="`sortable-${index}`"
                >
                    <el-table-column label="排序" width="48" class-name="sort-handle">
                        <span class="el-icon-sort"></span>
                    </el-table-column>
                    <!-- <el-table-column prop="ticketName" label="票品名称" show-overflow-tooltip></el-table-column> -->
                    <el-table-column label="票品" min-width="200">
                        <template slot-scope="scope">                            
                            <div>
								{{scope.row.ticketName}}
								<span v-if="scope.row.groupId == 2"  class="color-gary2">(车票)</span>
								<span v-if="scope.row.groupId == 3"  class="color-gary2">(权益票)</span>
								<!-- 权益票展示绑定的主票品名称 -->
								<div v-if="scope.row.groupId == 3 && scope.row.mainPriceName" class="color-gary2">主票品：{{scope.row.mainPriceName}}</div>
							</div>
							<el-popover
								placement="right"
								width="400"
								trigger="hover"
								v-if="scope.row.instruction"
								>
								<div>{{scope.row.instruction}}</div>
								<span slot="reference" class="color-success hand el-icon-thumb"> 票品说明</span>
							</el-popover>
                        </template>
                    </el-table-column>                    
					<el-table-column label="销售状态" min-width="100">
					    <template slot-scope="scope">
					        <span v-if="scope.row.status == 0" class="color-success">正常销售</span>
					        <span v-else-if="scope.row.status == 2" class="color-warning">优惠码销售</span>
                            <span v-else-if="scope.row.status == 3">白名单销售</span>
					        <span v-else-if="scope.row.status == 1" class="color-info">暂停销售</span>
					    </template>
					</el-table-column>
					<el-table-column label="票品形态" min-width="130">
					    <template slot-scope="scope">
					        <span v-if="scope.row.ticketType == 1">电子票 
								<span v-if="scope.row.electronicType == 1">- 二维码</span>
								<span v-if="scope.row.electronicType == 2">- 身份证</span>
							</span>
					        <span v-else-if="scope.row.ticketType == 2">实体票寄送</span>
					        <span v-else-if="scope.row.ticketType == 3">实体票自取</span>
							<span v-else-if="scope.row.ticketType == 4">实体票自取/寄送</span>
					    </template>
					</el-table-column>
					<el-table-column label="观演人和下单人" min-width="160" show-overflow-tooltip>
					   <template slot-scope="scope">
						   <p>
								观演人：<span v-if="scope.row.buyType == 2 && scope.row.realName == 1 " class="color-danger">购票时绑定</span>
								<span v-else-if="scope.row.buyType == 3 && scope.row.realName == 1 " class="color-success">购票后绑定</span>
								<span v-else-if="scope.row.buyType == 0 || scope.row.realName == 0 ">无须绑定</span>
						   </p>
						   <p class="color-blue">
								下单人：<span v-if="scope.row.realNameValidType == 1">证件二要素认证</span>
								<span v-else-if="scope.row.realNameValidType == 2">身份证人脸认证</span>
								<span v-else>无须实名认证</span>
						   </p>
					   </template>
					</el-table-column>
                    <!-- <el-table-column label="二维码加锁" min-width="90">
                        <template slot-scope="scope">
                            <span v-if="scope.row.ticketQrCodeShowTime" class="color-success">已加锁</span>
                            <span v-else>未加锁</span>
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="sellPrice" label="价格" min-width="150">
                        <template slot-scope="{row} = scope">
                            <!-- <p>售价：{{ row.sellPrice }}元</p> -->
							<span>售价：{{ row.sellPrice }}元<sup class="sup" v-if="row.isUndetermined == 1">价格待定</sup></span>							
                            <p class="color-gary">原价：<del>{{ row.originalPrice }}</del>元</p>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="originalPrice" label="原价" min-width="90"></el-table-column> -->
                    <el-table-column prop="accountLimitNum" label="账号限购">
                        <template slot-scope="scope">
                            {{scope.row.accountLimitNum == 0 ? '不限购' : scope.row.accountLimitNum}}
                        </template>
                    </el-table-column>                    
                    <el-table-column prop="totalNum" label="总库存(票)"></el-table-column>
                    <el-table-column label="已销售（票） = 正常销售 + 候补成功" min-width="220">
						<template slot-scope="scope">
							<div v-if="scope.row.sellNum + scope.row.successCount > 0">
								<span>{{scope.row.sellNum + scope.row.successCount}}=</span>
								<span>{{scope.row.sellNum}}+{{ scope.row.successCount}}</span>	
							</div>
							<div v-else>
								{{scope.row.sellNum + scope.row.successCount}}
							</div>
							<p class="color-success">总人数：{{ (scope.row.sellNum + scope.row.successCount) * scope.row.memberNum}}</p>
						</template>						
					</el-table-column>
                    <el-table-column prop="occupyNum" label="待支付(票)"></el-table-column>
                    <el-table-column prop="leftNum" label="剩余可售（票）" min-width="120">
						<template slot-scope="scope">
							<span>{{scope.row.leftNum }}<sup class="sup" v-if="scope.row.isSoldOut == 1">强制售罄</sup></span>
						</template>
					</el-table-column>
					<el-table-column prop="altLeftNum" label="候补库存（票）" min-width="120"></el-table-column>
					<el-table-column label="候补数据（票）" min-width="120">
						<template slot-scope="scope">
						    <p class="color-warning">候补中：{{scope.row.amidCount}}</p>
						    <p class="color-success">候补成功：{{scope.row.successCount}}</p>
						    <p >历史总候补：{{scope.row.alternateTotalTickets}}</p>
						</template>						
					</el-table-column>
					<el-table-column label="跨票品托售" min-width="120">
					    <template slot-scope="scope">
					       <p> {{scope.row.crossAltPriceName && scope.row.crossAltPriceName != '' ? '已开启' : '未开启'}}</p>
						   <p v-if="scope.row.crossAltPriceName && scope.row.crossAltPriceName != ''" class="color-success">{{scope.row.crossAltPriceName}}</p>
					    </template>
					</el-table-column>
                    <el-table-column label="缺票登记">
                        <template slot-scope="scope">
                            {{scope.row.isAddGoods == 1 ? '已开启' : '已关闭'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="lackTicketsNum" label="缺票(人)"></el-table-column>					
                    <el-table-column prop="validateType" label="防黄牛验证" min-width="130">
                        <template slot-scope="scope">
                            <span v-if="scope.row.validateType == 0">不开启验证</span>
                            <span v-else-if="scope.row.validateType == 1">图形验证</span>
                            <span v-else-if="scope.row.validateType == 2">腾讯云验证</span>
                            <span v-else-if="scope.row.validateType == 3">Token验证</span>
                            <span v-else-if="scope.row.validateType == 4">腾讯云+Token验证</span>
                            <span v-else-if="scope.row.validateType == 5">订单token验证</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="memberNum" label="可进场人数" min-width="100"></el-table-column>
					<el-table-column prop="privilegeTotalNum" label="特权购库存" min-width="100"></el-table-column>
					<el-table-column prop="privilegeSellNum" label="特权购售票数" min-width="100"></el-table-column>
                    <el-table-column label="销售时间" min-width="170">
                        <template slot-scope="scope">
                            <p v-if="scope.row.startTime">起:{{scope.row.startTime}}</p>
                            <p v-if="scope.row.endTime">止:{{scope.row.endTime}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column label="销售时间展示" min-width="100">
                        <template slot-scope="scope">
                            {{scope.row.isHideStartDate == 1 ? '不展示' : '正常展示'}}
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="验票时间" min-width="170">
                        <template slot-scope="scope">
                            <p v-if="scope.row.validStartTime">起:{{scope.row.validStartTime}}</p>
                            <p v-if="scope.row.validEndTime">止:{{scope.row.validEndTime}}</p>
                        </template>
                    </el-table-column> -->
					<el-table-column label="票品ID" min-width="170" prop="id" ></el-table-column>
                    <el-table-column v-if="data && !data.haveEditAudit" fixed="right" label="操作" width="680">
                        <template slot-scope="scope">
							<template v-if="$utils.have('/activity/saveTPs') ">
								<el-button
									v-if="data && !data.channelName"
									type="text"
									size="small"
									@click="editShowstart(data.channelName,scope.row,{id:item.sessionId,name:item.sessionName})"
									>查看</el-button
								><!-- 秀动  -->
								<el-button
									v-else
									type="text"
									size="small"
									@click="edit(data.channelName,scope.row,{id:item.sessionId,name:item.sessionName})"
									>查看</el-button
								><!-- 非秀动  -->
							</template>
							<!-- 票品复制（保存即生效，需求 7130854148），放在调整库存前 -->
							<el-button
								v-if="$utils.have('/activity/copyTP') && data && !data.channelName && !data.haveEditAudit"
								type="text"
								size="small"
								@click="copyTicket(scope.row, item)"
								>复制</el-button
							>
                            <el-button
                                v-if="$utils.have('/activity/adjustStocks') && data && !data.channelName"
                                type="text"
                                size="small"
                                @click="editTickStock(scope.row)"
                                >调整库存</el-button
                            >
							<el-button
							    v-if="$utils.have('/activity/adjustSellNum') && data && !data.channelName"
							    type="text"
							    size="small"
							    @click="editDataStock(scope.row)"
							    >调整数据</el-button
							>
                            <el-button
                                v-if="$utils.have('/activity/saveTicketRecord')"
                                type="text"
                                size="small"
                                @click="saveTicketRecord(scope.row)"
                                >票品登记</el-button
                            >
							<el-button
							    v-if="$utils.have('/activity/openAlternate') && data && !data.channelName "
							    type="text"
							    size="small"
							    @click="openAlternate(scope.row,item.time)"								
							    >
								<span :class="scope.row.isOpenAlternate == 0 ? 'color-danger' : ''">
									{{scope.row.isOpenAlternate == 1 ? '已开启候补' : '已关闭候补'}}
								</span>															
							</el-button>
                            <el-button
							    v-if="$utils.have('/activityTicketWhite/pageList') && scope.row.status == 3 && data && !data.channelName"
							    type="text"
							    size="small"
                                @click="$refs.whiteList.show(id,scope.row.id)">
								白名单设置							
							</el-button>
							<el-button
							    v-if="$utils.have('/activity/openConsign') && data && !data.channelName "
							    type="text"
							    size="small"
							    @click="openConsign(scope.row,item.time)"
							    >
								<span :class="scope.row.isOpenConsign == 0 ? 'color-danger' : ''">
									{{scope.row.isOpenConsign == 1 ? '已开启托售' : '已关闭托售'}}
								</span>												
							</el-button>
							<el-button
							    v-if="$utils.have('/activity/updateTicketPriceIsTight') && data && !data.channelName"
							    type="text"
							    size="small"
							    @click="lowStock(scope.row)"
							    >
								<span :class="scope.row.isTight == 0 ? 'color-danger' : ''">
									{{scope.row.isTight == 0 ? '已关闭余票紧张' : '已开启余票紧张'}}
								</span>												
							</el-button>
							<el-button
							    v-if="$utils.have('/activityTicketWhite/commonPerformerEdit') && scope.row.realName == 1 "
							    type="text"
							    size="small"
							    @click="astrictUser(scope.row)"
							    >
								<span :class="scope.row.isCommonPerformerList == 1 ? 'color-danger' : ''">
									{{scope.row.isCommonPerformerList == 0 ? '未限制观演人' : '已限制观演人'}}	</span>
							</el-button>
							<!-- 定时购白名单（开启后显示，按钮放在操作列最后，需求 7121828104） -->
							<el-button
							    v-if="scope.row.isOpenWhitelist == 1"
							    type="text"
							    size="small"
							    @click="setPreBuyWhitelist(scope.row)"
							    >
								定时购白名单
							</el-button>

                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div>
            <el-button @click="goBack">返回</el-button>
        </div>
        <!-- 票品编辑 -->
        <ticket-prices-edit ref="ticketPricesEdit" :activityId="id" @onUpdate="getDatalist" :type="0" :isSeat="data && data.isSeat"></ticket-prices-edit>
		<!-- 票品编辑秀动 -->
		<ticket-prices-edit-showstart ref="ticketPricesEditShowstart" :activityId="id" @onUpdate="getDatalist" :type="0" :isSeat="data && data.isSeat"></ticket-prices-edit-showstart>
		<!-- 票品复制 -->
		<ticket-copy ref="ticketCopy" :activityId="id" @onUpdate="getDatalist"></ticket-copy>	
        <!-- 库存调整 -->
        <ticket-stock-edit ref="ticketStockEdit" :activityId="id"  @onUpdate="getDatalist"></ticket-stock-edit>
		<!-- 调整数据 -->
		<data-stock-edit ref="dataStockEdit" :activityId="id"  @onUpdate="getDatalist"></data-stock-edit>
        <!-- 缺票登记 -->
        <ticket-prices-record ref="ticketPricesRecord" :activityId="id" @onUpdate="getDatalist"></ticket-prices-record>
		<!-- 候补设置 -->
		<ticket-open-alternate ref="TicketOpenAlternate" :activityId="id" @onUpdate="getDatalist"></ticket-open-alternate>
        <!-- 白名单 -->
        <white-list ref="whiteList"></white-list>
		<!-- 托售设置 -->
		<ticket-open-consign ref="TicketOpenConsign" :activityId="id" @onUpdate="getDatalist"></ticket-open-consign>
		<!-- 限制观演人 -->
		<ticket-astrict-user ref="TicketAstrictUser" :activityId="id" @onUpdate="getDatalist"></ticket-astrict-user>
		<import-ticket-seat ref="importTicketSeat" :activityId="id" @onUpdate="getDatalist"></import-ticket-seat>
		<!-- 定时购白名单导入 -->
		<pre-buy-whitelist ref="preBuyWhitelist" @onUpdate="getDatalist"></pre-buy-whitelist>
    </div>
</template>

<script>
import Tab from '../components/tab';
import TicketPricesEdit from '../components/ticket-prices-edit';
import TicketPricesEditShowstart from '../components/ticket-prices-edit-showstart';
import TicketStockEdit from '../components/ticket-stock-edit';
import DataStockEdit from '../components/data-stock-edit';
import TicketPricesRecord from '../components/ticket-prices-record';
import TicketOpenAlternate from '../components/ticket-open-alternate';
import TicketOpenConsign from '../components/ticket-open-consign';
import Sortable from "sortablejs";
import WhiteList from '../components/whiteList.vue';
import TicketAstrictUser from '../components/ticket-astrict-user';
import ImportTicketSeat from './components/ticket-prices-seat';
import PreBuyWhitelist from '../components/pre-buy-whitelist.vue';
import TicketCopy from '../components/ticket-copy.vue';
export default {
    props:{
        id: {
            type: [Number, String],
            default: () => null
        }
    },
    components:{
        Tab,TicketPricesEdit,TicketPricesEditShowstart,TicketStockEdit,DataStockEdit,TicketPricesRecord,TicketOpenAlternate,TicketOpenConsign,WhiteList,TicketAstrictUser,ImportTicketSeat,PreBuyWhitelist,TicketCopy
    },
    data(){
        return{
            dataLoading:false,
            data:null,
            dataList:[],
            osIndex: 0,
            redirect: this.$route.query.redirect,
        }
    },
    computed:{
        // memberNum(){
        //     return{
        //         1: '单人',
        //         2: '双人',
        //         3: '三人',
        //         4: '四人',
        //         5: '五人',
        //         6: '六人',
        //         7: '七人',
        //         8: '八人',
        //         9: '九人',
        //         10: '十人'
        //     }
        // }
    },
    mounted(){
        this.getDatalist();
    },
    methods:{
        //返回
        goBack() {
            if(this.redirect){
                this.$router.push({
                    path: this.redirect,
                });
            }else{
                this.$router.go(-1);
            }
        },
        //获取列表
        getDatalist(){
            this.dataLoading = true;
            this.$request({
                url: "/activity/ticketPrices",
                params: { activityId: parseInt(this.id) },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.data = result;
                        this.dataList = result.sessionTicketPrices;                   
                        this.drag();
                        
                    } else {
                        self.$message.error(msg || "获取场次票品失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取场次票品失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        add(){
            this.$refs.ticketPricesEdit.show();
        },
		addShowstart(){
		    this.$refs.ticketPricesEditShowstart.show();
		},
        edit(channelName,item,sessionVo){
            this.$refs.ticketPricesEdit.show(channelName,item,sessionVo,);
        },
		editShowstart(channelName,item,sessionVo){
			this.$refs.ticketPricesEditShowstart.show(channelName,item,sessionVo,);
		},
        //复制票品（打开复制弹层，传入源票品、源场次与全部场次数据）
        copyTicket(row, session){
            this.$refs.ticketCopy.show(row, session, this.dataList);
        },
        //调整库存
        editTickStock(item){
            this.$refs.ticketStockEdit.show(item)
        },
		editDataStock(item){
			this.$refs.dataStockEdit.show(item)
		},
        //缺票登记
        saveTicketRecord(item){
            this.$refs.ticketPricesRecord.show(item);
        },
		openAlternate(item,time){
		    this.$refs.TicketOpenAlternate.show(item,time);	
		},
		openConsign(item,time){
		    this.$refs.TicketOpenConsign.show(item,time);	
		},
		//限制观演人
		astrictUser(item){
			this.$refs.TicketAstrictUser.show(item);
		},
		//座位号
		setSeat(data){
			this.$refs.importTicketSeat.show(data);
		},
		//定时购白名单设置（导入/下载）
		setPreBuyWhitelist(row){
			this.$refs.preBuyWhitelist.show(row);
		},
		lowStock(data){
			var _ticketPriceId = data.id;
			var _isTight = data.isTight;			
			const _msg = _isTight == 1 ? ' 确认要关闭余票紧张?' : '确认打开余票紧张?'
			this.$confirm(_msg, '提示', {
			    type: 'warning',
			    center: true,
			    closeOnClickModal: false
			}).then(() => {
			    this.listLoading = true;
			    this.$request({
			        url: '/activity/updateTicketPriceIsTight',
			        method: 'POST',
			        data: {
						activityId: parseInt(this.id),
						isTight:_isTight == 1 ? 0 : 1,
						ticketPriceId: _ticketPriceId
					}
			    }).then(res => {
			        const { state, msg } = res.data;
			        if( state == 1 ){
						this.$message.success('操作成功');
			            this.getDatalist();
			        }else{
			            this.$message.error(msg || '操作失败');
			        }
			    }).finally(() => {
			        this.listLoading = false;
			    });
			})
		},
        //拖拽排序
        drag(){
            this.$nextTick(() => {
                this.dataList.forEach((item,index) => {
                    const el = document.querySelectorAll('.sortable-'+index+'> .el-table__body-wrapper > table > tbody')[0];
                    Sortable.create(el, {
                        disabled: this.data.haveEditAudit, // 拖拽不可用? false 启用
                        ghostClass: 'sortable-ghost', //拖拽样式
                        animation: 150, // 拖拽延时，效果更好看
                        handle: ".sort-handle",
                        onEnd: (e) => { // 拖拽结束时的触发
                            let arr = [...item.ticketPrices]; // 获取表数据
							
                            arr.splice(e.newIndex, 0, arr.splice(e.oldIndex, 1)[0]); // 数据处理，获取最新的表格数据
                            
                            this.$nextTick(function () {
                                const a1 = (item.ticketPrices.map(a => a.id)).toString();
                                const a2 = (arr.map(a => a.id)).toString();
                                if(a1 != a2){
                                    item.ticketPrices = arr;
                                    this.osIndex = index;
                                    this.updateTickPricesSort();
									
                                }
                            })
                        },
                    });
                })
            })
        },
        //排序
        updateTickPricesSort(){
			console.log(this.dataList[this.osIndex].ticketPrices)
            this.dataList[this.osIndex].ticketPrices.map( (item,index) => {
                item.sort = index;
            })			
            this.$request({
                url: '/activity/ticketSort',
                method: "post",
                data: this.dataList[this.osIndex].ticketPrices,
            })
                .then((res) => {
                    //处理成功回调
                    const { state, msg } = res.data;
                    if (state && state == 1) {
                        this.$message.success("排序成功");
						window.location.reload()
						
                    } else {
                        return this.$message.error(msg || "操作失败");
                    }
                })
                .catch(() => {
                    this.$message.error("操作失败,请重试");
                })
                .finally(() => {
                    
                });
        },
    }
}
</script>


<style lang="scss" scoped>
.page-list-box{
    >div{
        margin-bottom: 20px;
    }
}
.color-gary{
	color:#bebcbc
}
.color-gary2{
	color:#999
}
.item {
  margin-top: 10px;
  margin-right: 40px;
  font-size: 10px;
}
.sup{
	color:#fff;
	padding:0 2px;
	font-size: 10px;
	background: #f56c6c;
	border-radius: 8px;
	border:1px solid #f00
}
::v-deep .el-button--mini{
	padding:7px;
	font-size: 10px;
}
.hand{
		cursor: pointer;
	}
</style>